@if ((display_tour_name || display_match_status) && !faceoff) {
    <section class="match-details header">
        <div class="match-details-left">
            @if (match_data.status === 'playing') {
                <span class="live-tag"> Live </span>
            }

            @if (display_tour_name && !showOnlyCourt) {
                <div class="tour-name">{{ match_data.tournament_name }}</div>
            }

            @if (display_match_status && match_data.status === 'suspended') {
                <span class="status-pill suspended" aria-label="suspended">
                    {{ appStringAPI.getAppString('tennis.match.suspended') }}
                </span>
            }

            @if (match_data.court?.name && showOnlyCourt) {
                <div class="tour-name">{{ match_data.court?.name }}</div>
            }

            @if (!match_data.status && is_today && !showOnlyCourt) {
                <div class="match-date">{{ appStringAPI.getAppString('tennis.oop.no.court.info') }} {{ match_data.starts_at | date: 'shortTime' }}</div>
            }

            @if (display_match_status && match_data.display_status) {
                <!-- <div class="match-status" [class]="match_data.status">
                    <app-app-string [match_status_string]="match_data.display_status"></app-app-string>
                </div> -->
            }

            @if (round?.name) {
                <div class="match-round-name">
                    {{ round?.name }}

                    @if (match_data.duration && match_data.status !== 'postponed') {
                        <span style="margin-left: 0.8em; text-transform: lowercase">{{ formatMatchDuration(match_data.duration || '') }}</span>
                    }
                </div>
            }
        </div>
        @if (showMatchChat()) {
            <div class="chat-pill" (click)="viewMatchDetails()">
                <mat-icon>chevron_right</mat-icon>
            </div>
        }
    </section>
}

@if (!faceoff) {
    <div (click)="viewMatchDetails()" style="position: relative" [ngStyle]="from_match_details ? {} : { padding: '5px' }">
        <app-match-team [team]="match_data.team1" [opponent_set]="match_data.team2.sets" [match_status]="match_data.status" class="team1"></app-match-team>

        <app-match-team [team]="match_data.team2" [opponent_set]="match_data.team1.sets" [match_status]="match_data.status" class="team2"></app-match-team>

        <!-- @if (display_tour_name || display_match_status) {
            <div class="spacer" class="match-details"></div>
        } -->

        @if (from_match_details && match_data.court?.name) {
            <div class="commentary" style="text-align: center">{{ match_data.court?.name }}</div>
        }

        @if (match_data.status === 'playing' && comment) {
            <div class="commentary">{{ comment }}</div>
        }
    </div>
}
@if (faceoff) {
    <section class="match-details footer">
        <div class="match-details-left">
            @if (faceoff.starts_at) {
                <div>
                    @if (!from_player_history) {
                        {{ matchDateFormat.formatDate(faceoff.starts_at.toString(), dateFormat(), { timeZone: 'UTC' }) }}

                        @if (faceoff.tournament_name) {
                            <span> - {{ faceoff.tournament_name }}</span>
                        }
                    } @else if (from_player_history) {
                        {{ matchDateFormat.formatDate(faceoff.starts_at.toString(), dateFormat(), { timeZone: 'UTC' }) }}

                        @if (round?.name) {
                            <span> - {{ round?.name }}</span>
                        }
                    }
                </div>
            }
        </div>

        <div class="match-details-right">
            @if (faceoff.status === 'finished_retired') {
                <span class="status-pill retired" aria-label="retired">
                    {{ appStringAPI.getAppString('tennis.match.retired') }}
                </span>
            }

            @if (faceoff.status === 'finished_walkover') {
                <span class="status-pill walkover" aria-label="walkover">
                    {{ appStringAPI.getAppString('tennis.match.walkover') }}
                </span>
            }
        </div>
    </section>

    <div>
        <app-match-team [team]="faceoff.team1" [opponent_set]="faceoff.team2.sets" class="team1" [faceoff_scores]="true"></app-match-team>
        <app-match-team [team]="faceoff.team2" [opponent_set]="faceoff.team1.sets" class="team2" [faceoff_scores]="true"></app-match-team>
    </div>

    @if (faceoff && faceoff.tournament_name) {
        <div class="tournament-detail">
            {{ faceoff.tournament_name }}
            <mat-icon>chevron_right</mat-icon>
        </div>
    }
}
